var render = function render(){var _vm=this,_c=_vm._self._c;return _c('modal',{attrs:{"show":_vm.showModal,"modal-classes":"modal-secondary","size":"lg"}},[(_vm.taxGroup)?_c('edit-tax-group-component',{attrs:{"taxGroupId":_vm.taxGroup.id,"only-taxes":""},on:{"onViewTaxGroup":_vm.openTaxGroupViewModal,"cancelEdition":_vm.closeFormModal}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }